module.exports = __webpack_public_path__ + "img/jin1.3d315947.png";